import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../environments/environment';

let uri = "";
let uri_upload = "";
let uri_download = "";

if (environment.production === false ) {
  uri = `${environment.apiProtocol}://${environment.apiServer}:${environment.apiPort}/api`; //`${environment.apiProtocol}://${environment.apiServer}:${environment.apiPort}`; AppConfiguration  // `${environment.apiProtocol}://${environment.apiServer}:${environment.apiPort}/api`; //`${environment.apiProtocol}://${environment.apiServer}:${environment.apiPort}`;
  uri_upload = 'http://localhost:3000/api/upload'
  uri_download = 'http://localhost:3000/public/';
}else{
  uri = `${environment.apiPath}`; //`${environment.apiProtocol}://${environment.apiServer}:${environment.apiPort}/${environment.apiPath}`;
  uri_upload =  `${environment.apiPathUpload}`; //'https://t4a.com.pe/node/api/upload'
  uri_download = `${environment.apiPathPublic}`; //'https://t4a.com.pe/node/public/';
}

//uri = 'http://localhost:3000/api'

export const BASE_URL_API = uri;
export const BASE_URL_UPLOAD = uri_upload;
export const BASE_URL_DOWNLOAD = uri_download;

@Injectable()
export class AppService {

  // variables
  public endpoint = '/';

  constructor(
    public http: HttpClient
  ) {
/*
    if(appconfig.production){
      uri = `${appconfig.apiPath}`; //`${environment.apiProtocol}://${environment.apiServer}:${environment.apiPort}/${environment.apiPath}`;
      uri_upload = `${appconfig.apiPathUpload}`;
      uri_download = `${appconfig.apiPathPublic}`
    }
    else{
      uri = `${appconfig.apiProtocol}://${appconfig.apiServer}:${appconfig.apiPort}/api`;
      uri_upload = 'http://localhost:3000/api/upload'
      uri_download = 'http://localhost:3000/public/';
    }*/

  }

  public generateHeaders(type?: any): HttpHeaders {
    let token = null;
    if (localStorage.getItem('token')) {
      token = localStorage.getItem('token');
    }
    let httpHeaders = null;
    if (token) {
      httpHeaders = new HttpHeaders({'Content-Type': 'application/json', Authorization: 'Bearer ' + token});
    } else {
      httpHeaders = new HttpHeaders({'Content-Type': 'application/json'});
    }
    return httpHeaders;
  }

  public generateHeadersAuthorization(): HttpHeaders {
    const credenciales = btoa('osiptel' + ':' + '1234567890');
    const httpHeaders = new HttpHeaders({
      Authorization: 'Basic ' + credenciales
    });
    return httpHeaders;
  }

  get<T>(url: any, type?: any): Observable<any> {
    const headers = this.generateHeaders(type);
    return this.http.get<T[]>(url, {headers, responseType: type});
  }

  postAuthorization(url: any, object: any, headers?: HttpHeaders): Observable<any> {
    //const headers = this.generateHeadersAuthorization();
    return this.http.post(url, object, {headers, responseType: 'json'});
  }

  post(url: any, object: any, type?: any): Observable<any> {
    const headers = this.generateHeaders(type);
    return this.http.post(url, object, {headers, responseType: 'json'});
  }

  patch(url, data: any, accessToken: string = null): Observable<any> {
    const headers = this.generateHeaders();
    return this.http.patch(url, data, {headers});
  }

  put(url: any, object: any, type?: any): Observable<any> {
    const headers = this.generateHeaders(type);
    return this.http.put(url, object, {headers, responseType: type});
  }

  delete(url: any, type?: any): Observable<any> {
    const headers = this.generateHeaders(type);
    return this.http.delete(url, {headers, responseType: type});
  }

  generate(url: any, object: any): Observable<any> {
    const headers = this.generateHeaders();
    return this.http.post(url, object, {headers, responseType: 'blob'});
  }

  request(req: any): Observable<any> {
    const token = JSON.parse(localStorage.getItem('currentUser')).access_token;
    const headers = new HttpHeaders({'Content-Type': 'application/json', Authorization: 'Bearer ' + token});
    return this.http.request(req);
  }
}
